import { useState, useEffect } from 'react';

export default function useDocumentSubscription (ref, dependencies = [], { onError = e => { throw e }, } = {}) {
  const [item, setItem] = useState();
  useEffect(() => {
    if(!ref) return setItem(undefined);

    const unsubscribe = ref
      .onSnapshot((doc) => {
        if(doc.exists) {
          setItem({ id: doc.id, ref, ...doc.data() });
        } else {
          setItem(null);
        }
      }, onError);
    return unsubscribe;
  }, dependencies);
  return item;
};
